import classNames from "classnames"
import { capitalizeFirstLetter } from "legacy/helpers.es6.jsx"
import PropTypes from "prop-types"
import React from "react"

class WeekendDays extends React.Component {
  constructor(props) {
    super(props)
    this.toggleDay = this.toggleDay.bind(this)
    this.buildDay = this.buildDay.bind(this)
  }

  toggleDay(day) {
    this.props.toggleDay(day)
  }

  buildDay(day) {
    // always require one to be selected, disable the checkbox is there is only one selected
    const length = Object.keys(this.props.days).length
    const hasDay = Object.hasOwn(this.props.days, day)
    return (
      <div
        className={classNames("checkbox", {
          disabled: length <= 1 && hasDay,
        })}
      >
        <label>
          <input
            type="checkbox"
            onChange={() => this.toggleDay(day)}
            checked={hasDay}
            disabled={length <= 1 && hasDay}
          />{" "}
          {capitalizeFirstLetter(day)}
        </label>
      </div>
    )
  }

  render() {
    return (
      <div
        className={classNames("rate-form-group", "weekend-days", {
          "show-weekend-days": this.props.show,
        })}
      >
        {this.buildDay("thursday")}
        {this.buildDay("friday")}
        {this.buildDay("saturday")}
        {this.buildDay("sunday")}
      </div>
    )
  }
}

WeekendDays.propTypes = {
  days: PropTypes.object.isRequired,
  toggleDay: PropTypes.func.isRequired,
  show: PropTypes.bool,
}

export default WeekendDays
